
    import common from "@/util/common";
    import {useStore} from "@/store";
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, toRefs, reactive} from "vue";

    interface State {
        baseInfo:  object[];
        photoList: object[];
        showTip: boolean;

    }

    export default defineComponent({
        name: "carInfoH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                baseInfo: [],
                photoList: [],
                showTip: false,

            })
            let store = useStore()
            const router = useRouter();
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
            state.baseInfo = getData('carInfo', 'items');
            state.photoList = getData('photoList', 'items');
            window.addEventListener('click', () => {
                state.showTip = false;
            });
            return {
                state,
                router,
                store,
                getData

            }
        },
        components: {
        },
        methods: {
            goCarInfo () {
                this.store.dispatch('savePageScrollTop', window.scrollY);
                this.$router.push('/promiseFrameCarInfo');
            },

            goToImgView(photo) {
                this.store.dispatch('savePageScrollTop', window.scrollY);
                if (photo === 'all') {
                    this.router.push({
                        path:'/promiseFramePhotoListExport',
                        query: {
                            photoIndex:0,
                            group: 'base',
                            isAll: 'total',
                        }
                    })
                } else {
                    let currentIndex=0;
                    for (let i =0;i<this.state.photoList.length;i++){
                        let item: any = this.state.photoList[i];
                        if (item.code === photo.code) {
                            currentIndex = i;
                            break;
                        }
                    }
                    this.router.push({
                        path:'/promiseFramePhotoListExport',
                        query: {
                            photoIndex: currentIndex,
                            group: 'base' ,
                        }
                    })
                }
            }
        }
    })
